import { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}
const UserAscentIcon: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      {...props}
    >
      <path
        d="M18.625 4.10156C18.625 4.44656 18.3451 4.72656 18 4.72656H14.8636V7.43988C14.8636 8.00069 14.4087 8.45573 13.8476 8.45573H11.1018V11.2932C11.1018 11.8549 10.6469 12.3091 10.0858 12.3091H7.34001V14.9607C7.34001 15.5216 6.8855 15.9766 6.32438 15.9766H3C2.65495 15.9766 2.375 15.6966 2.375 15.3516C2.375 15.0057 2.65495 14.7266 3 14.7266H6.09001V12.0749C6.09001 11.5141 6.54492 11.0591 7.10604 11.0591H9.85183V8.22154C9.85183 7.66072 10.3067 7.2057 10.8678 7.2057H13.6136V4.49239C13.6136 3.93158 14.0681 3.47656 14.6292 3.47656H18C18.3451 3.47656 18.625 3.75656 18.625 4.10156Z"
        fill={props.fill || "currentColor" || "#3064C0"}
      />
      <path
        d="M7.54223 3.65987C7.65983 3.77736 7.72575 3.93656 7.72575 4.10237L7.72168 6.69988C7.72087 7.04488 7.44091 7.32488 7.09546 7.32406C6.75041 7.32325 6.47086 7.04325 6.47168 6.69825L6.47331 5.61264L3.44189 8.64323C3.19775 8.8874 2.80225 8.8874 2.55811 8.64323C2.31396 8.39906 2.31396 8.00323 2.55811 7.75904L5.5883 4.72997L4.50594 4.73241C4.16089 4.73322 3.88053 4.45404 3.87971 4.10822C3.87891 3.76322 4.15804 3.48322 4.5035 3.48241L7.09912 3.47656C7.26554 3.47656 7.42505 3.54238 7.54223 3.65987Z"
        fill={props.fill || "currentColor" || "#3064C0"}
      />
    </svg>
  );
};

export default UserAscentIcon;
